/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserActivityEventFromJSON, UserActivityEventToJSON, } from './';
export function CreateUserActivityRequestFromJSON(json) {
    return CreateUserActivityRequestFromJSONTyped(json, false);
}
export function CreateUserActivityRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        token: !exists(json, 'token') ? undefined : json['token'],
        timestamp: new Date(json['timestamp']),
        event: UserActivityEventFromJSON(json['event']),
        value: json['value'],
    };
}
export function CreateUserActivityRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        token: value.token,
        timestamp: value.timestamp.toISOString(),
        event: UserActivityEventToJSON(value.event),
        value: value.value,
    };
}
